import { OwnedAssistanceProduct } from '@/interfaces';
import {
  RSA_AR006,
  RSA_AR007,
  RSA_AR008,
  RSA_AR009,
  RSA_AR010,
  RSA_ARV002,
  RSA_ROADSIDE_EXCESS_USE,
  RSA_ARN001,
  RSA_ARN002,
  RSA_ARN003,
  RSA_ARN004,
  RSA_ARN005,
  RSA_ARN006,
  RSA_ARN007,
  RoadsideProductType,
} from '../roadside-helpers';

const showOnlinePromoCard = (policy: OwnedAssistanceProduct): boolean => {
  const shouldShow =
    !!policy?.productCode &&
    [RSA_AR006, RSA_AR007, RSA_AR008, RSA_AR009, RSA_AR010, RSA_ARV002, RSA_ROADSIDE_EXCESS_USE].includes(
      policy.productCode
    );

  return shouldShow;
};

const showPhonePromoCard = (policy: OwnedAssistanceProduct): boolean => {
  return (
    !!policy?.productCode &&
    (policy.roadsidePolicyType === RoadsideProductType.Cmo ||
      [RSA_ARN001, RSA_ARN002, RSA_ARN003, RSA_ARN004, RSA_ARN005, RSA_ARN006, RSA_ARN007].includes(policy.productCode))
  );
};

export const RSAPromoCardRules = {
  showOnlinePromoCard,
  showPhonePromoCard,
};
